import { TRANSITIONS, DEFAULT_STATE, FINITE_STATE } from './utils';
import HANDLERS from './handlers';

export default {
    data() {
        return {
            currentState: DEFAULT_STATE,
            finiteState: FINITE_STATE
        };
    },
    created() {
        if (!(TRANSITIONS instanceof Object)) {
            throw '"TRANSITIONS" must be an object';
        }
        if (!(HANDLERS instanceof Object)) {
            throw '"HANDLERS" must be an object';
        }
        this.command(DEFAULT_STATE, {});
    },
    computed: {
        stateTip() {
            const path = `booksBuilds.tips.${this.currentState}`;
            return this.$te(path) ? this.$t(path) : undefined;
        }
    },
    methods: {
        async command(nextState, action, event = {}) {
            const handler = HANDLERS[nextState];
            await this.$nextTick();
            handler && handler.call(this, { ...action, event });
        },
        transition(action, event = {}) {
            const { [this.currentState]: actions = {} } = TRANSITIONS;
            const { type } = action;
            const { [type]: next } = actions;
            const node = `${this.currentState}/${type}`;

            if (!next) {
                throw new Error(`Invalid transition definition for state node '${node}'`);
            }

            console.log(`[transition]: ${node}`);

            Object.assign(this.$data, {
                currentState: next,
                ...this.command(next, action, event)
            });
        }
    }
};
